// extracted by mini-css-extract-plugin
export default {"section":"xm7A1ihqCh12S7N2IsHN","anchor":"QOSgiLZQuA_RpecCEJDC"};